import * as React from "react";
import { Divider } from "antd";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpSwitch } from "../../../gvc/testNewForm/CpSwitch";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";

interface Props {}
export const AddonNvidia: React.FC<Props> = ({}) => {
  const isEnabled = useCpFormValue(`addons.nvidia.isEnabled`);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <Divider orientation="left" orientationMargin={0}>
        Add-On | NVIDIA
      </Divider>
      <div id={`addon-nvidia`} style={{ scrollMarginTop: 200 }}>
        <div className="flex items-center gap-2">
          <CpLabel name={`addons.nvidia.taintGPUNodes`}>Taint GPU Nodes</CpLabel>
          <CpSwitch name={`addons.nvidia.taintGPUNodes`} />
        </div>
      </div>
    </>
  );
};
